import { render, staticRenderFns } from "./IconLess.vue?vue&type=template&id=64d6c784&"
import script from "./IconLess.vue?vue&type=script&lang=js&"
export * from "./IconLess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports